import classNames from 'classnames';

import { Svg } from '@components/svg/Svg';

import styles from './listing-carousel-header.module.scss';

interface ListingCarouselHeaderProps {
	title: string;
	isPreviousButtonDisabled: boolean;
	isNextButtonDisabled: boolean;
	scrollTo: (sibling: 'previousElementSibling' | 'nextElementSibling') => void;
	className?: string;
}

export const ListingCarouselHeader = ({
	title,
	isPreviousButtonDisabled,
	isNextButtonDisabled,
	scrollTo,
	className,
}: ListingCarouselHeaderProps) => {
	return (
		<header className={classNames(className, styles.header)}>
			<div className={styles['heading-wrapper']}>
				<h2 className={styles.heading}>{title}</h2>
				<Svg className={styles['hand-drawn-stroke']} id="hand-drawn-stroke-1" />
			</div>
			<Svg className={styles['hand-drawn-star']} id="hand-drawn-star" />
			<div className={styles.buttons}>
				<button
					aria-label="Previous"
					className={styles.button}
					disabled={isPreviousButtonDisabled}
					onClick={() => {
						scrollTo('previousElementSibling');
					}}
					type="button"
				>
					<Svg id="arrow-serial-output" />
				</button>
				<button
					aria-label="Next"
					className={styles.button}
					disabled={isNextButtonDisabled}
					onClick={() => {
						scrollTo('nextElementSibling');
					}}
					type="button"
				>
					<Svg id="arrow-serial-output" />
				</button>
			</div>
		</header>
	);
};
